import { Spinner as SpinnerC, type SpinnerProps } from '@chakra-ui/react'

export default function Spinner({ ...props }: SpinnerProps): React.ReactElement {
  return (
    <SpinnerC
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.muted"
      color="primary.solid"
      size="xl"
      {...props}
    />
  )
}
